import { put, select } from 'redux-saga/effects';

import { getInDomain } from '../../../domains/externalUtils';
import * as Selectors from '../../../selectors';
import * as Utils from '../../../utils';

export function* isInPremiumAccessSession() {
  const isAdSupported = yield select(Selectors.Payments.productTierIsAdSupported);
  const isPlus = yield select(Selectors.Payments.productTierIsPlus);
  const hasPremiumFeatures = yield select(Utils.Listener.hasPremiumFeatures);

  return (isAdSupported || isPlus) && hasPremiumFeatures;
}

export function* sourceStarted({ payload: { sourceId } }) {
  const isInPASession = yield select(isInPremiumAccessSession);
  const isCollectionEmpty = yield select(
    getInDomain('collection.utils.getIsAllFilteredCollectionEmpty'),
  );
  const annotations = yield select(getInDomain('catalog.utils.getAnnotations'), sourceId);
  const isCompilation = annotations.get('isCompilation', false);
  const artistId = yield select(getInDomain('catalog.utils.getPremiumSourceArtistId'), sourceId);

  if (isInPASession && isCollectionEmpty && artistId && !isCompilation) {
    yield put(getInDomain('playback.actions.createStation')({ pandoraId: artistId }));
  }
}
